import React, {
    useRef,
    useEffect,
} from 'react';
import PropTypes from 'prop-types';

function IframeListener({ listener, ...props }) {
    const iframeEl = useRef(null);
    const attachedListener = listenClickOnIframe(iframeEl, listener);

    useEffect(() => {
        window.addEventListener('blur', attachedListener);
        return () => {
            window.removeEventListener('blur', attachedListener);
        };
    }, [attachedListener]);

    const children = React.Children.map(props.children, (child) =>
        React.cloneElement(child, { getIframeRef: () => iframeEl })
    );

    return children;
}

IframeListener.propTypes = {
    listener: PropTypes.func.isRequired,
};

function listenClickOnIframe(ref, listener) {
    function listenClick() {
        setTimeout(() => {
            if (document.activeElement === ref.current) {
                listener();
            }
        }, 0);
    }

    return listenClick;
}

export default IframeListener;
